import { render, staticRenderFns } from "./ListIconCustoms.vue?vue&type=template&id=509835c2"
import script from "./ListIconCustoms.vue?vue&type=script&lang=js"
export * from "./ListIconCustoms.vue?vue&type=script&lang=js"
import style0 from "./ListIconCustoms.vue?vue&type=style&index=0&id=509835c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports